import Styles from './ArrayInput.module.scss'
import InputStyles from 'almanac-ui/TextInputField/Input.module.scss'
import cx from 'classnames'
import { SnippetsPillsInput } from './SnippetsPillsInput'
import { TagInput } from './TagInput'
import { FieldProps } from './Types'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'

export const ArrayInput = ({ name, schema, autoFocus }: FieldProps) => {
  const {
    meta: { mobilePlaceholder, placeholder, snippets },
  } = schema.describe()

  if (snippets) {
    return (
      <>
        <ResponsiveDesign.Mobile>
          <SnippetsPillsInput
            name={name}
            placeholder={mobilePlaceholder || placeholder}
            autoFocus={autoFocus}
            isSingleLine
          />
        </ResponsiveDesign.Mobile>
        <ResponsiveDesign.Desktop>
          <SnippetsPillsInput name={name} placeholder={placeholder} autoFocus={autoFocus} isSingleLine />
        </ResponsiveDesign.Desktop>
      </>
    )
  }

  return (
    <>
      <div
        className={cx(
          InputStyles['lg'],
          InputStyles.input,
          InputStyles.withBorder,
          InputStyles.tagArrayInputWrapper,
          Styles.tagInputContainer,
        )}
      >
        <TagInput
          name={name}
          placeholder={placeholder}
          autoFocus={autoFocus}
          placeholderClassName={Styles.placeholder}
        />
      </div>
    </>
  )
}
